import React, { ReactNode, useRef } from "react";

import styled from "styled-components";

import { BottomFade, ScrollChevron, ScrollHint, useScrollAffordance } from "@/components/CartModal/phoneTemplate";

import { ScrollArea } from "./styles";

const Outer = styled.div`
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: column;
`;

/**
 * The shared scroll body for the LicenseModal-family modals (Choose Your
 * Option / Choose Your Plan / License Terms): the `ScrollArea` PLUS the
 * mandatory phone-template scroll affordance — a bottom fade + a gently
 * bouncing "Scroll ⌄" hint that shows only while there's more below and clears
 * at the bottom (docu/modal-template-phone.md "Scroll affordance").
 *
 * Use this instead of a bare `<ScrollArea>` so the affordance is never missed.
 * Reuses the cart's reusable pieces (the template's shared home).
 */
const ModalScrollArea: React.FC<{ children: ReactNode }> = ({ children }) => {
  const bodyRef = useRef<HTMLDivElement>(null);
  const canScrollDown = useScrollAffordance(bodyRef);
  return (
    <Outer>
      <ScrollArea ref={bodyRef}>{children}</ScrollArea>
      <BottomFade $visible={canScrollDown}>
        <ScrollHint>
          <span>Scroll</span>
          <ScrollChevron />
        </ScrollHint>
      </BottomFade>
    </Outer>
  );
};

export default ModalScrollArea;
